'use-client';
import * as React from 'react';
import type { HoneycombProps } from '../Honeycomb.types';
import TPAGallery from '../../TPAGallery/viewer/TPAGallery';

const Honeycomb: React.FC<HoneycombProps> = props => {
  return <TPAGallery {...props}></TPAGallery>;
};

export default Honeycomb;
